import { render, staticRenderFns } from "./dap-project.page.vue?vue&type=template&id=774fbe14&scoped=true"
import script from "./dap-project.page.vue?vue&type=script&lang=ts"
export * from "./dap-project.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-project.page.vue?vue&type=style&index=0&id=774fbe14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fbe14",
  null
  
)

export default component.exports